import { useTranslations } from "@jugl-web/utils";
import React, { ReactNode } from "react";
import { CRMInfoSection } from "../../../../components/CRMInfoSection";
import { ReactComponent as AIAgentIcon } from "./assets/ai-agent.svg";
import { ReactComponent as CallsIcon } from "./assets/calls.svg";
import { ReactComponent as CreditsIcon } from "./assets/credits.svg";
import { ReactComponent as InboxIcon } from "./assets/inbox.svg";

const descriptionRichTextValues = {
  b: (chunks: ReactNode) => <span className="font-semibold">{chunks}</span>,
  br: <br />,
};

export const HowItWorksTab: React.FC = () => {
  const { t } = useTranslations();

  return (
    <div className="mx-auto flex w-full max-w-[1200px] flex-col gap-8 overflow-y-auto p-8 max-lg:gap-4 max-lg:p-4">
      <CRMInfoSection
        title={t({
          id: "client-support-page.how-it-works-title",
          defaultMessage: "How it works",
        })}
        subtitle={t({
          id: "client-support-page.how-it-works-everything-you-need-to-know",
          defaultMessage: "Everything you need to know",
        })}
        items={[
          {
            icon: <AIAgentIcon />,
            title: t({
              id: "client-support-page.how-it-works-voice-ai-agent-title",
              defaultMessage: "AI Agent",
            }),
            description: t(
              {
                id: "client-support-page.how-it-works-voice-ai-agent-description",
                defaultMessage:
                  "<b>🔵 Instructions:</b> You can set custom AI Agent instructions or use available base one{br}<b>🟢 Knowledge:</b> AI Agent will use available Knowledge, Business Name and Training Sources{br}<b>❌ Not supported:</b> Automations, Collect Leads, Escalate to Human, and Agent tone.",
              },
              descriptionRichTextValues
            ),
          },
          {
            icon: <CallsIcon />,
            title: t({
              id: "client-support-page.how-it-works-voice-calls-title",
              defaultMessage: "Calls",
            }),
            description: t({
              id: "client-support-page.how-it-works-voice-calls-description",
              defaultMessage:
                "After setup, all incoming calls will be handled by AI Agent automatically. Agent will greet customer with indicated Welcome message.",
            }),
          },
          {
            icon: <CreditsIcon />,
            title: t({
              id: "client-support-page.how-it-works-voice-credits-title",
              defaultMessage: "Message Credits usage",
            }),
            description: t({
              id: "client-support-page.how-it-works-voice-credits-description",
              defaultMessage:
                "AI Agent will use 4 Message Credits per every 1 minute of conversation",
            }),
          },
          {
            icon: <InboxIcon />,
            title: t({
              id: "client-support-page.how-it-works-voice-inbox-title",
              defaultMessage: "See conversations in Inbox",
            }),
            description: t({
              id: "client-support-page.how-it-works-voice-inbox-description",
              defaultMessage:
                "All Calls will be saved in the Inbox Module in a text format",
            }),
          },
        ]}
      />
    </div>
  );
};
